import { isDev } from '../config/env.js'
import './EnvBanner.css'

const EnvBanner = () => {
  if (!isDev) return null
  return <div className="env-banner" role="status">TEST-UMGEBUNG</div>
}

export default EnvBanner
